export const listRatingSize = 15;
